import type { Infer } from "superstruct";

import { docSchema } from "../Document";

export const UserDataSchema = docSchema({});
export type UserDataFields = Infer<typeof UserDataSchema>;
